import { createAction} from 'redux-actions';

import * as ENV from '../constants/env';

export const setHasInternet = createAction(ENV.INTERNET_CHANGED);
